import React from "react";
import { Helmet } from "react-helmet";
import { GET_ROTA } from "../../../queries/staff.query";
import { useQuery } from "@apollo/react-hooks";
import LoadingSpinner from "../../../partials/loading.jsx";
import StaffRotaList from "./StaffRotaItems.jsx";
import { AppName, CleanMessage } from "../../../util/app";
import { toast } from "react-toastify";

function StaffRota({ staff, location }) {
    const title = "Staff Rota";

    const { loading, data } = useQuery(GET_ROTA, {
        variables: {
            staff: staff.id
        },
        onError: e => toast.error(CleanMessage(e.message))
    });

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>
            <strong
                style={{
                    fontSize: "1.3em"
                }}
            >
                {title}
            </strong>
            <div className="row">
                <div className="col-md-12">
                    <LoadingSpinner loading={loading} />
                </div>
                {!loading && data && (
                    <div className="col-md-12">
                        <StaffRotaList items={data.GetStaffRotas.docs} />
                    </div>
                )}
            </div>
        </>
    );
}
export default StaffRota;
